// This was generated during the migration to @kiwicom/eslint-config
// PLEASE REMOVE THE GLOBAL ESLINT DISABLE BELOW
// AND FIX ERRORS ACCORDINGLY.
/* eslint-disable jsx-a11y/alt-text */
import React from "react"

type Props = {
  imgSrc: string
  imgSrcSet?: string | null | undefined
  header: string
  text: string
  href?: string | null | undefined
}

const FullpageMessage = ({ imgSrc, imgSrcSet, header, text, href }: Props) => (
  <div className="FullPageMessage">
    <div className="FullPageMessage-centeredContainer">
      {/* @ts-expect-error: Flow to TS migration. */}
      <img className="FullPageMessage-image" src={imgSrc} srcSet={imgSrcSet} />
      <span className="FullPageMessage-header spTypo-display spTypo-bold">{header}</span>
      {href ? (
        <a className="FullPageMessage-link spTypo-headline spTypo-bold" href={href}>
          {text}
        </a>
      ) : (
        <div className="FullPageMessage-text">{text}</div>
      )}
    </div>
  </div>
)

FullpageMessage.defaultProps = {
  imgSrcSet: undefined,
  href: undefined,
}

export default FullpageMessage
